






















































































































import Vue from 'vue'
import { ApiResponse, Contact, Structure, FormContact, Model } from '@/interfaces'
import { mapState } from 'vuex'

interface SendMailData {
  contacts: string[]
  customText?: string
  structure?: number | null
  chosenModel?: number | null
}

interface StructureSelect {
  id: number | null
  name: string | null
  type: string | null
}

interface Recipient {
  id: number | null
  email: string | null
  label?: string | null
}

export default Vue.extend({
  props: {
    showSendMailModal: {
      type: Boolean,
      default: false,
    },
    sendMailData: {
      type: Object as () => SendMailData,
      required: false,
      default: null,
    },
    parentType: {
      type: String,
      required: false,
      default: '',
    },
    parentId: {
      type: Number,
      required: false,
      default: null,
    },
    sendDocumentType: {
      type: String,
      required: false,
      default: null,
    },
    defaultSendContact: {
      type: Object as () => Contact,
      required: false,
      default: null,
    },
    debiteurSendContact: {
      type: Object as () => Contact,
      required: false,
      default: null,
    },
    saleId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      busy: false,
      showModal: false,
      structures: [] as StructureSelect[],
      contacts: [] as FormContact[],
      recipients: [] as Recipient[] | null,
      newContact: null as FormContact | null,
      models: [] as Model[],
      chosenModel: null as number | null,
      buyersEmail: [] as FormContact[],
      addons: 0,
      previewActiveNames: [] as string[],
    }
  },
  computed: {
    ...mapState(['user']),
    modalTitle() {
      if (this.parentType === 'invoiceForm') {
        return 'Envoi de facture par mail'
      } else if (this.parentType === 'invoiceList') {
        return 'Envoi de facture(s) par mail'
      } else if (this.parentType === 'massSale') {
        return 'Emailing vendeur'
      } else if (this.parentType === 'massBuyer') {
        return 'Emailing acheteur facturé'
      } else if (this.parentType === 'massBuyerStockItems') {
        return 'Emailing aux acheteurs possédant des lots payés mais non récupérés'
      } else if (this.parentType === 'sale') {
        return 'Envoi de document de vente par mail'
      } else {
        return 'Envoi de document par mail'
      }
    },
    view() {
      if (this.parentType === 'invoiceForm' || this.parentType === 'invoiceList') {
        return 'mail-invoice'
      } else if (this.parentType === 'massSale') {
        return 'mail-seller'
      } else if (this.parentType === 'massBuyer') {
        return 'mail-buyer'
      } else if (this.parentType === 'massBuyerStockItems') {
        return 'mail-buyer'
      } else if (this.parentType === 'sale') {
        return 'mail-document'
      } else {
        return 'mail-document'
      }
    },
    invalidRecipientEmails(): string[] {
      return (this.recipients ?? [])
        .map((recipient: Recipient) => recipient.email)
        .filter((email): email is string => !!email && !this.isValidEmail(email))
    },
    selectedModelHtml(): string {
      return this.models.find((model: Model) => model.id === this.sendMailData.chosenModel)?.html ?? ''
    },
  },
  watch: {
    user(newVal) {
      if (Array.isArray(newVal.client.structures)) {
        this.structures = []
        newVal.client.structures.forEach((structure: Structure) => {
          this.structures.push({
            id: structure.id ?? null,
            name: structure.name ?? null,
            type: structure.type ?? null,
          })
        })

        // If there's only one structure, it should be selected by default
        if (this.structures.length == 1) {
          this.sendMailData.structure = this.structures[0].id
        }
      }

      this.addons = newVal.client?.addons ?? 0
    },
    showSendMailModal(newVal) {
      this.showModal = newVal
      this.recipients = []
      if (this.defaultSendContact) {
        const defaultContact = {
          label: this.defaultSendContact.formName ?? null,
          value: this.defaultSendContact.email ?? null,
        }
        this.addContact(defaultContact)
        if (this.defaultSendContact?.additionalEmails && this.defaultSendContact?.additionalEmails?.length > 0) {
          this.defaultSendContact?.additionalEmails?.forEach((additionalEmail: string) => {
            //this.addNonExistingEmail(additionalEmail)
            this.addContact({ label: this.defaultSendContact.formName ?? null, value: additionalEmail })
          })
        }
      }
      if (this.debiteurSendContact) {
        const debiteur = {
          label: this.debiteurSendContact.formName ?? null,
          value: this.debiteurSendContact.email ?? null,
        }
        this.addContact(debiteur)
        if (this.debiteurSendContact?.additionalEmails && this.debiteurSendContact?.additionalEmails?.length > 0) {
          this.debiteurSendContact?.additionalEmails?.forEach((additionalEmail: string) => {
            //this.addNonExistingEmail(additionalEmail)
            this.addContact({ label: this.debiteurSendContact.formName ?? null, value: additionalEmail })
          })
        }
      }
      if (newVal && this.parentType === 'massSale' && this.saleId) {
        this.getSellers(this.saleId)
      }
      if (newVal && this.parentType === 'massBuyer' && this.saleId) {
        this.getBuyers(this.saleId)
      }
      if (newVal && this.parentType === 'massBuyerStockItems' && this.saleId) {
        this.getBuyersWithStockItems(this.saleId)
      }
      if (this.models.length === 0) {
        this.getTemplates()
      }
    },
  },
  mounted() {
    if (this.user) {
      this.addons = this.user.client?.addons ?? 0

      // Update structures
      this.structures = this.user.client.structures

      // If there's only one structure, it should be selected by default
      if (this.structures.length == 1) {
        this.sendMailData.structure = this.structures[0].id
      }
    }
  },
  methods: {
    addonTest(code: number) {
      if (!isNaN(this.addons)) {
        return BigInt(code) & BigInt(this.addons)
      } else {
        return false
      }
    },
    closeSendMailForm() {
      this.$emit('closeSendEmailForm')
    },
    noSubmit() {
      return false
    },
    submit() {
      try {
        this.$set(this.sendMailData, 'contacts', this.recipients)
        this.$emit('submit', this.sendMailData)
      } finally {
        this.closeSendMailForm() // 🔓 réactive le bouton
      }
    },
    disabledForm() {
      return (
        (this.parentType !== 'invoiceList' &&
          this.parentType !== 'massSale' &&
          this.parentType !== 'massBuyer' &&
          this.parentType !== 'massBuyerStockItems' &&
          this.recipients?.length === 0) ||
        (this.parentType === 'massSale' && !this.sendMailData.structure) ||
        (this.parentType === 'massBuyer' && !this.sendMailData.structure) ||
        (this.parentType === 'massBuyerStockItems' && !this.sendMailData.structure) ||
        !this.sendMailData.chosenModel ||
        this.invalidRecipientEmails.length > 0 ||
        this.busy
      )
    },
    searchContacts(search: string, cb: CallableFunction) {
      if (search && search.length >= 2) {
        this.busy = true
        let results = [] as FormContact[]
        this.contacts = [] as FormContact[]
        this.$api
          .get('/contacts', {
            params: {
              search: search ?? null,
            },
          })
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            apiResponse.data.forEach((contact: Contact) => {
              let contactName = contact.formName
              if (contact.email) {
                contactName = `${contactName} - (${contact.email})`
                this.contacts.push({ value: contact.email ?? null, label: contactName ?? null })
              }
            })
            results = search ? this.contacts.filter(this.createFilter(search)) : this.contacts
          })
          .finally(() => {
            cb(results)
            this.contacts = results
            this.busy = false
          })
      } else {
        this.contacts = []
      }
    },
    createFilter(search: string) {
      return (contact: FormContact) => {
        return contact.label?.toLowerCase()?.indexOf(search.toLowerCase()) !== -1 ?? null
      }
    },
    // formatSendContact(contact: Contact) {
    //   let contactInfos = `${contact.formName}`
    //   // if (contact.email) {
    //   //   contactInfos = `${contactInfos} - (${contact.email})`
    //   // }
    //   return contactInfos
    // },
    findEmailIndex(email: string) {
      return this.recipients?.findIndex((recipient: Recipient) => email === recipient.email) ?? -1
    },
    formatRecipientTag(recipient: Recipient): string {
      const label = recipient.label?.trim()
      if (!label) {
        return recipient.email ?? ''
      }

      const email = recipient.email
      // if (!email || label.toLowerCase().includes(email.toLowerCase())) {
      //   return label
      // }

      return `${label} (${email})`
    },
    isValidEmail(email: string | null): boolean {
      if (!email) {
        return false
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      return emailRegex.test(email)
    },
    addContact(contact: FormContact) {
      // pas de dédoublonnage : plusieurs contacts vendeurs peuvent partager une adresse e-mail
      //if (contact.value && this.findEmailIndex(contact.value) === -1) {
        const recipientInfo = {
          id: contact.id,
          email: contact.value,
          label: contact.label,
        } as Recipient
        this.recipients?.push(recipientInfo)
        this.closeContactSelect()
      //}
    },
    deleteContact(email: string) {
      const emailIndex = this.findEmailIndex(email)
      if (emailIndex > -1) {
        this.recipients?.splice(emailIndex, 1)
      }
    },
    closeContactSelect() {
      this.newContact = null
      this.contacts = []
    },
    addNonExistingEmail(email: string) {
      if (this.contacts.length === 0) {
        const nonExistingRecipient = {
          id: null,
          email,
        } as Recipient
        this.recipients?.push(nonExistingRecipient)
        this.closeContactSelect()
      }
    },
    getTemplates() {
      this.$api.get(`/model/${this.view}/list`).then((response) => {
        const apiResponse = response.data as ApiResponse

        this.models = apiResponse.data
      })

      // If there's only one model, it should be selected by default
      /*
      if (this.models.length == 1) {
        this.sendMailData.chosenModel = this.models[0]
      }
      */
    },
    // Get buyers with Items in Stock and invoice paid
    getBuyersWithStockItems(saleId: number) {
      this.$api
        .get(`/sale/${saleId}/buyers`, {
          params: {
            mode: 'withStockItems',
          },
        })
        .then((response) => {
          const apiResponse = response.data as ApiResponse
          this.buyersEmail = apiResponse.data
          ;(this.buyersEmail as FormContact[]).forEach((contact: FormContact) => {
            this.addContact(contact)
          })
        })
    },
    // Get buyers
    getBuyers(saleId: number) {
      this.$api
        .get(`/sale/${saleId}/buyers`, {
          params: {
            mode: 'all',
          },
        })
        .then((response) => {
          const apiResponse = response.data as ApiResponse
          this.buyersEmail = apiResponse.data
          ;(this.buyersEmail as FormContact[]).forEach((contact: FormContact) => {
            this.addContact(contact)
          })
        })
    },
    getSellers(saleId: number) {
      this.$api.get(`/sale/${saleId}/sellers`).then((response) => {
        const apiResponse = response.data as ApiResponse
        ;(apiResponse.data as FormContact[]).forEach((contact: FormContact) => {
          this.addContact(contact)
        })
      })
    },
  },
})
